export default __webpack_public_path__ + "467aa934770f30445b07079510e40562.svg";